module.exports = __webpack_public_path__ + "static/img/icon_heart_r.961b779c.svg";